// World 14 (Ballast) — fourth post-launch expansion world. Introduces the
// GRAVITY CELL mechanic: certain board cells carry permanent direction
// arrows; tiles that end a slide on a gravity cell immediately re-slide
// in the arrow's direction (subject to normal stopping rules). See
// packages/engine/src/slide.ts gravityLoop. This is the first cell-attribute
// mechanic — every prior world's freshness lived on tiles. Ballast moves
// the mechanic into the board itself, so the grid stops being passive and
// starts having potential energy.
//
// Spec: docs/future/w14-ballast-plan.md.
//
// Progression: L1-L4 are d=8 openers (gravityCount=1-2, 4 colors, r=3 + r=4
// mix); L5-L10 climb to d=9 with branching 20.33 → 26.45 and richer
// gravity placements. The depth lift to d=8-9 (vs W11/W13's d=6-7) is
// possible because gravity delivers "free distance" to slides — admissible
// heuristic compresses the per-cell move bound, so deeper boards stay
// solver-budget-feasible.
//
// Generator: tools/generate-parallel.mjs --world 14 (180s solver budget,
// gravityCount=1-3 across cfg0..cfg3, mixed r=3/r=4 geometry).
// Seed 0xaebcf000. 50 candidates pooled across 4 configs in ~16479s
// (~4.6h walltime, 4-worker pool). Worker config dist:
//   cfg0 r=3 t=12 c=4 g=1: 13/100 accepted, all d=8
//   cfg1 r=3 t=13 c=4 g=2: 25/100 accepted, mix d=8 (16) + d=9 (9)
//   cfg2 r=4 t=13 c=4 g=2: 9/100 accepted, all d=8
//   cfg3 r=4 t=14 c=5 g=3: 3/100 accepted, all d=8 (78% truncated — d=9
//     proofs at r=4/5c are at the edge of solver budget; acceptable for
//     ballast since the d=9 progression is carried by cfg1)
//
// Note: no d=10 levels survived selection — generator config wanted 5 d=8
// + 5 d=9 + 2 d=10, with topUp from d=9 if d=10 sparse. d=10 turned out
// to be too sparse in the W14 search space at 180s budget; the topUp ran
// and we shipped 5 d=8 + 5 d=9. d=10 W14 levels are a v1.x stretch.
//
// Status: parked for drip-release alongside W11/W12/W13. Import is NOT
// uncommented in levels/index.ts — the drop happens via the 4-edit + 2-
// command procedure in docs/future/drip-release-playbook.md.
import type { LevelDef } from '@tessera/engine';
import { WORLD_14_GENERATED } from './world14-generated';

export const WORLD_14_LEVELS: LevelDef[] = [...WORLD_14_GENERATED];
